<template>
    <div>
  <template v-for="(stat, idx) in progressStats" >
            <v-row :key="idx" >
                <v-col cols="12">
                    <base-card>
                        <v-card-title>                                                        
                            <div class="d-flex justify-space-between flex">
                                <div class="d-flex justify-center px-3 pt-2">                                       
                                    <h5 class="ml-2" style="display: inline-block" ><a target="_blank" :href="stat.assetUrl"><img style="vertical-align: middle;" :src="stat.assetThumbnail"  alt="" width="60" /></a> <span class="ml-10">{{stat.type}}</span></h5> 
                                </div>     
                                <div class="d-flex justify-center  pt-2">                                       
                                    <a target="_blank" :href="stat.assetUrl"><h5 class="mr-4" style="display: inline-block; color: gray"  >{{stat.assetName}}</h5></a>
                                </div>                              
                            </div>
                        </v-card-title>                                        
                    
                    </base-card>
                </v-col>
            </v-row>
            <v-row :key="idx+'2a'">
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    Goal: {{stat.total_target}}
                                </div>
                                <v-list-item-title class="headline mb-1 font-weight-bold">{{shouldBeDash(stat.total_actual)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Current Total Impressions</span
                                        >
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <apexchart
                                width="100"
                                height="120"
                                type="radialBar"
                                :options="getRatioWidgetData(stat.total_actual, stat.total_target).chartOptions"
                                :series="getRatioWidgetData(stat.total_actual, stat.total_target).series"
                            />
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    Target Daily Avg.: {{stat.daily_avg_target}}
                                </div>
                                <v-list-item-title
                                    class="headline mb-1 font-weight-bold"
                                    >{{shouldBeDash(stat.today_actual)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Today's Total</span
                                        >
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <!-- <v-sheet
                                height="60"
                                width="60"
                                class="primary lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: red;"
                                    >mdi-arrow-down</v-icon
                                >
                            </v-sheet> -->
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    Target Daily Avg.: {{stat.daily_avg_target}}
                                </div>
                                <v-list-item-title
                                    class="headline mb-1 font-weight-bold"
                                    >{{shouldBeDash(stat.daily_avg_actual)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Actual Daily Avg. (All Time)</span
                                        >
                                    </div>
                                </v-list-item-subtitle>

                            </v-list-item-content>
                            <v-sheet
                                v-if="stat.daily_avg_actual >= stat.daily_avg_target"
                                height="60"
                                width="60"
                                class="success lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: green;"
                                    >mdi-arrow-up</v-icon
                                >
                            </v-sheet>
                            <v-sheet
                                v-else
                                height="60"
                                width="60"
                                class="primary lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: red;"
                                    >mdi-arrow-down</v-icon
                                >
                            </v-sheet>
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    Target Daily Avg.: {{stat.daily_avg_last3days_target}}
                                </div>
                                <v-list-item-title
                                    class="headline mb-1 font-weight-bold"
                                    >{{shouldBeDash(stat.daily_avg_last_3days_actual)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Actual Daily Avg. (Last 3 Days)</span
                                        >
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-sheet
                                v-if="stat.daily_avg_last_3days_actual >= stat.daily_avg_last3days_target"
                                height="60"
                                width="60"
                                class="success lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: green;"
                                    >mdi-arrow-up</v-icon
                                >
                            </v-sheet>
                            <v-sheet
                                v-else
                                height="60"
                                width="60"
                                class="primary lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: red;"
                                    >mdi-arrow-down</v-icon
                                >
                            </v-sheet>
                        </v-list-item>
                    </base-card>
                </v-col>                                
            </v-row>   

            <v-row v-if="stat.hasOwnProperty('total_actual_WebTrueImpression')" :key="idx+'2aa'">
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    Impressions: {{stat.total_actual}}
                                </div>
                                <v-list-item-title class="headline mb-1 font-weight-bold">{{shouldBeDash(stat.total_actual_WebTrueImpression)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Current Total True Impressions</span
                                        >
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <apexchart
                                width="100"
                                height="120"
                                type="radialBar"
                                :options="getRatioWidgetData(stat.total_actual_WebTrueImpression, stat.total_actual).chartOptions"
                                :series="getRatioWidgetData(stat.total_actual_WebTrueImpression, stat.total_actual).series"
                            />
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    &nbsp;
                                </div>
                                <v-list-item-title
                                    class="headline mb-1 font-weight-bold"
                                    >{{shouldBeDash(stat.today_actual_WebTrueImpression)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Today's Total - True Impressions</span
                                        >
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <!-- <v-sheet
                                height="60"
                                width="60"
                                class="primary lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: red;"
                                    >mdi-arrow-down</v-icon
                                >
                            </v-sheet> -->
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    &nbsp;
                                </div>
                                <v-list-item-title
                                    class="headline mb-1 font-weight-bold"
                                    >{{shouldBeDash(stat.daily_avg_actual_WebTrueImpression)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Actual Daily Avg. (All Time) - True Impressions</span
                                        >
                                    </div>
                                </v-list-item-subtitle>

                            </v-list-item-content>
                            <!-- <v-sheet
                                v-if="stat.daily_avg_actual >= stat.daily_avg_target"
                                height="60"
                                width="60"
                                class="success lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: green;"
                                    >mdi-arrow-up</v-icon
                                >
                            </v-sheet>
                            <v-sheet
                                v-else
                                height="60"
                                width="60"
                                class="primary lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: red;"
                                    >mdi-arrow-down</v-icon
                                >
                            </v-sheet> -->
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    &nbsp;
                                </div>
                                <v-list-item-title
                                    class="headline mb-1 font-weight-bold"
                                    >{{shouldBeDash(stat.daily_avg_last_3days_actual_WebTrueImpression)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Actual Daily Avg. (Last 3 Days) - True Impressions</span
                                        >
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <!-- <v-sheet
                                v-if="stat.daily_avg_last_3days_actual >= stat.daily_avg_last3days_target"
                                height="60"
                                width="60"
                                class="success lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: green;"
                                    >mdi-arrow-up</v-icon
                                >
                            </v-sheet>
                            <v-sheet
                                v-else
                                height="60"
                                width="60"
                                class="primary lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: red;"
                                    >mdi-arrow-down</v-icon
                                >
                            </v-sheet> -->
                        </v-list-item>
                    </base-card>
                </v-col>                                
            </v-row>


            <v-row v-if="stat.hasOwnProperty('total_actual_WebClick')" :key="idx+'2aaa'">
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    True Impressions: {{stat.total_actual_WebTrueImpression}}
                                </div>
                                <v-list-item-title class="headline mb-1 font-weight-bold">{{shouldBeDash(stat.total_actual_WebClick)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Current Total Clicks</span
                                        >
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <apexchart
                                width="100"
                                height="120"
                                type="radialBar"
                                :options="getRatioWidgetData(stat.total_actual_WebClick, stat.total_actual_WebTrueImpression).chartOptions"
                                :series="getRatioWidgetData(stat.total_actual_WebClick, stat.total_actual_WebTrueImpression).series"
                            />
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    &nbsp;
                                </div>
                                <v-list-item-title
                                    class="headline mb-1 font-weight-bold"
                                    >{{shouldBeDash(stat.today_actual_WebClick)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Today's Total - Clicks</span
                                        >
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <!-- <v-sheet
                                height="60"
                                width="60"
                                class="primary lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: red;"
                                    >mdi-arrow-down</v-icon
                                >
                            </v-sheet> -->
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    &nbsp;
                                </div>
                                <v-list-item-title
                                    class="headline mb-1 font-weight-bold"
                                    >{{shouldBeDash(stat.daily_avg_actual_WebClick)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Actual Daily Avg. (All Time) - Click</span
                                        >
                                    </div>
                                </v-list-item-subtitle>

                            </v-list-item-content>
                            <!-- <v-sheet
                                v-if="stat.daily_avg_actual >= stat.daily_avg_target"
                                height="60"
                                width="60"
                                class="success lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: green;"
                                    >mdi-arrow-up</v-icon
                                >
                            </v-sheet>
                            <v-sheet
                                v-else
                                height="60"
                                width="60"
                                class="primary lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: red;"
                                    >mdi-arrow-down</v-icon
                                >
                            </v-sheet> -->
                        </v-list-item>
                    </base-card>
                </v-col>
                <v-col cols="3">
                    <base-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <!-- <v-list-item-subtitle class="body-2">Total</v-list-item-subtitle> -->
                                <div class="body-2 mb-0 text--disabled">
                                    &nbsp;
                                </div>
                                <v-list-item-title
                                    class="headline mb-1 font-weight-bold"
                                    >{{shouldBeDash(stat.daily_avg_last_3days_actual_WebClick)}}</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                    <div class="d-flex flex-wrap">
                                        <span class="font-weight-bold text-info"
                                            >Actual Daily Avg. (Last 3 Days) - Clicks</span
                                        >
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <!-- <v-sheet
                                v-if="stat.daily_avg_last_3days_actual >= stat.daily_avg_last3days_target"
                                height="60"
                                width="60"
                                class="success lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: green;"
                                    >mdi-arrow-up</v-icon
                                >
                            </v-sheet>
                            <v-sheet
                                v-else
                                height="60"
                                width="60"
                                class="primary lighten-5  d-inline-flex align-center justify-center rounded-circle mr-1"
                            >
                                <v-icon style="color: red;"
                                    >mdi-arrow-down</v-icon
                                >
                            </v-sheet> -->
                        </v-list-item>
                    </base-card>
                </v-col>                                
            </v-row>

            <v-row :key="idx+'2b'">
                <v-col cols="12">
                    <base-card>
                        <div class="d-flex align-center justify-space-between pr-3">
                            <v-card-title>Goal Tracking - {{stat.type}}</v-card-title>
                        </div>
                        <v-card-text>
                            <apexchart
                            type="line"
                            width="100%"
                            height="365"
                            :options="getGoalTrackingGraphData(stat).chartOptions"
                            :series="getGoalTrackingGraphData(stat).series"
                            />
                        </v-card-text>
                    </base-card>
                </v-col>                                            
            </v-row>
        </template>
    </div>
</template>

<script>
import {api} from "src/api/index";
import moment from "moment";

import { mapGetters, mapActions } from "vuex";
import { integerFormatting } from '@/core/number-utils.js'
export default {
  name: "CardDashboard",

  props: {
    selectedCampaign: {
        type: String,
        default: null
    },
    // title: {
    //   type: String,
    //   default: '\xa0',
    // },
    // primaryvalue: {
    //   type: String | Number,
    //   default: '\xa0',
    // },
    // unit: {
    //   type: String,
    //   default: '\xa0',
    // },

    // secondaryvalue: {
    //   type: String | Number,
    //   default: '\xa0',
    // },
  },
  data() {
    return {
        progressStats: [],
        progressStatsLoading: false,
    }
  },
  watch: {
    async selectedCampaign() {
        await this.fetchSelectedCampaignStatistics();
    }
  },
  methods: {
    shouldBeDash(src) {
      if ([0, '0', '0%', null].includes(src)) {
        return '-';
      }
      return src;
    },
    async fetchSelectedCampaignStatistics() {            
        if(!this.selectedCampaign) return;        
        this.progressStatsLoading = true;
        let rsp = await api.campaign.getCampaignProgressStatistics(this.selectedCampaign);            
        this.progressStats = rsp.data;
        this.progressStatsLoading = false;
        //console.log('MUST RE-FETCH STATS FOR CAMPAIGN: ' + selectedCampaign);
    },
    getGoalTrackingGraphData(dailyData) {
            let actualTimeSeries = [];
            let targetTimeSeries = [];

            let actualTimeSeries_WebClick = [];
            let actualTimeSeries_WebTrueImpressions = [];

            let targetDates = [];
            if(dailyData && dailyData.graphData) {
                actualTimeSeries = dailyData.graphData.map(g=>g.actual_amount_running_total);
            }
            if(dailyData && dailyData.graphData) {
                targetTimeSeries = dailyData.graphData.map(g=>g.target_amount_running_total);
            }
            if(dailyData && dailyData.graphData) {
                targetDates = dailyData.graphData.map(g=>g.tgtdate);
            }

            if(dailyData && dailyData.graphDataWebClick) {
                actualTimeSeries_WebClick = dailyData.graphDataWebClick.map(g=>g.actual_amount_running_total);
            }
            if(dailyData && dailyData.graphDataWebTrueImpression) {
                actualTimeSeries_WebTrueImpressions = dailyData.graphDataWebTrueImpression.map(g=>g.actual_amount_running_total);
            }

            let rslt = {                
                series: [
                    {
                    name: 'Impressions',
                    data: actualTimeSeries //[0, 200, 213*2 + 15, 213*3 + 70, 213*4 - 43, 213*5 - 190, 213*6 - 84, 213*7 - 170, 213*8 - 250],
                    },                    
                ],
                chartOptions: {
                    chart: {
                            height: 350,
                            type: 'line',
                            dropShadow: {
                                enabled: true,
                                color: '#000',
                                top: 18,
                                left: 7,
                                blur: 10,
                                opacity: 0.2,
                            },
                            toolbar: {
                                show: false,
                            },
                            },
                            colors: ['#28C76E'],
                            stroke: {
                            width: [4, 3, 3 ,3],
                            curve: 'straight',
                            },
                            markers: {
                            size: [6, 0],
                            },
                            dataLabels: {
                            enabled: false,
                            },
                            grid: {
                            strokeDashArray: 3,
                            },
                            xaxis: {
                            categories: targetDates,
                            axisBorder: {
                                show: false,
                            },
                            axisTicks: {
                                show: false,
                            },
                        },                              
                },
            }

            if(!(dailyData && dailyData.graphDataWebClick && dailyData.graphDataWebTrueImpression)) {
                rslt.series.push({
                    name: 'Goal',
                    data: targetTimeSeries
                },);
                rslt.chartOptions.colors.push('#8e8da2'); 
            }
            

            if(dailyData && dailyData.graphDataWebClick) {
                rslt.series.push({
                    name: 'Click',
                    data: actualTimeSeries_WebClick //[0, 200, 213*2 + 15, 213*3 + 70, 213*4 - 43, 213*5 - 190, 213*6 - 84, 213*7 - 170, 213*8 - 250],
                });
                rslt.chartOptions.colors.push('#FFA500');                
            }            

            if(dailyData && dailyData.graphDataWebTrueImpression) {
                rslt.series.push({
                    name: 'True Impression',
                    data: actualTimeSeries_WebTrueImpressions //[0, 200, 213*2 + 15, 213*3 + 70, 213*4 - 43, 213*5 - 190, 213*6 - 84, 213*7 - 170, 213*8 - 250],
                });
                rslt.chartOptions.colors.push('#33adff');   
            }

            return rslt;
        },
        getRatioWidgetData(actual, target) {
            let ratio = target ? Number(((actual / target) * 100).toFixed(2)) : 0;  
                        
            let initData = {};
            initData = {
                    series: [ratio],
                    chartOptions: {
                        chart: {
                        height: 120,
                        type: "radialBar"
                        },                                    
                        colors:["#33cc33"],
                        plotOptions: {
                        radialBar: {
                            hollow: {
                            margin: 0,
                            size: "50%"
                            },                    
                            dataLabels: {
                            show: true,
                            name: {
                                offsetY: 0,
                                show: false,
                                color: (ratio >= 0 ? "green" : "red"),
                                fontSize: "13px"
                            },
                            value: {
                                offsetY: 6,
                                color: "#828d99",
                                fontSize: "13px",
                                show: true,
                                fontWeight: 700,
                                formatter: function (val) {
                                    return Number(val).toFixed(2) + "%";
                                }
                                
                            }
                            }
                        }
                        },
                    
                        stroke: {
                        lineCap: "round",
                        },
                        labels: ["Progress"]
                    }
                }
            
            return initData;            
        }
  },
  async mounted() {    
    await this.fetchSelectedCampaignStatistics();
  }
  
  // computed: {
  //   ...mapGetters(["getThemeMode"]),
  // },
};
</script>

<style>

</style>